class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0, 'delete');
      console.log('cart-remove-button clicked');
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.cartErrors = document.getElementById('cart-errors');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
    document.addEventListener('cart:refresh', (event) => {
      const detail = event.detail || {};
      this.onExternalRefresh(detail);
    });
  }

  onChange(event) {
    if (event.target === null) return;
    const pfandHelperItem = event.target.closest('li[data-is-pfand-helper="true"]');
    if (pfandHelperItem && pfandHelperItem.closest('.mini-cart')) {
      pfandHelperItem.classList.add('disable-qty-change');
    }
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    let sections = [
      {
        id: 'mini-cart',
        section: document.getElementById('mini-cart')?.id,
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      },
    ];
    if (document.querySelector('#main-cart-footer .free-shipping')) {
      sections.push({
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.free-shipping',
      });
    }
    return sections;
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const sections = this.getSectionsToRender().map((section) => section.section);
    const scrollTop = document.querySelector('#main-cart-items')?.scrollTop;

    const body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname,
    });

    // Find the current <li> for this line : start ----------------------
    let pfandVariantId = null;
    let totalPfandHelperQty = 0;
    const currentLi = Array.from(document.querySelectorAll('.mini-cart__navigation li')).find((li) => {
      const input = li.querySelector('.quantity__input');
      return input && input.dataset.index == line;
    });
    // Check if this is a pfand-helper
    if (currentLi && currentLi.dataset.isPfandHelper === 'true') {
      pfandVariantId = currentLi.dataset.pfandVariantId; // get the pfand variant id
      // Get all pfand-helper items with the same pfandVariantId
      const pfandHelpers = Array.from(
        document.querySelectorAll('.mini-cart__navigation li[data-is-pfand-helper="true"]')
      ).filter((li) => li.dataset.pfandVariantId === pfandVariantId);
      // Sum their quantities
      pfandHelpers.forEach((li) => {
        const input = li.querySelector('.quantity__input');
        if (input) totalPfandHelperQty += parseInt(input.value, 10) || 0;
      });
    }
    // Check if this is a pfand-helper : end ----------------------

    fetch(`${theme.routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        // console.log('parsedState', parsedState);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        console.log('parsedState errors', parsedState.errors);
        if (parsedState.errors) {
          console.log('inside parsed state error');
          this.updateErrorLiveRegions(line, parsedState.errors);
        }

        // To delete the line item from the cart : start ----------------------
        if (quantity === 0 && name == 'delete' && currentLi && currentLi.dataset.isPfandHelper === 'true') {
          const pfandhelperCount = document.querySelectorAll(
            '.mini-cart__navigation li[data-is-pfand-helper="true"]'
          ).length;
          if (pfandhelperCount === 1) {
            // if there is only one pfand helper, delete the pfand product
            console.log('deleting pfand product from cart');
            this.updatePfandProductQuantity(pfandVariantId, 0);
          } else {
            // if there are multiple pfand helpers, update the pfand product quantity
            console.log('pfand helper count is not 1', pfandhelperCount);
            let totalPfandHelperQty = 0;
            // Get all pfand-helper items with the same pfandVariantId
            const newpfandHelpers = Array.from(
              document.querySelectorAll('.mini-cart__navigation li[data-is-pfand-helper="true"]')
            ).filter((li) => li.dataset.pfandVariantId === pfandVariantId);
            // Sum their quantities, excluding the current line being removed
            newpfandHelpers.forEach((li, index) => {
              const input = li.querySelector('.quantity__input');
              if (
                input &&
                parseInt(input.dataset.index, 10) !=
                  parseInt(currentLi.querySelector('.quantity__input').dataset.index, 10)
              ) {
                totalPfandHelperQty += parseInt(input.value, 10) || 0;
              }
              console.log('totalPfandHelperQty after removing current line', totalPfandHelperQty);
            });
            this.updatePfandProductQuantity(pfandVariantId, totalPfandHelperQty);
          }
        }
        // To delete the line item from the cart : end ----------------------

        this.getSectionsToRender().forEach((section) => {
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace = element.querySelector(section.selector) || element;

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          }
        });

        if (scrollTop && scrollTop > 0) {
          document.querySelector('#main-cart-items')?.scrollTo(0, scrollTop);
        }

        this.updateQuantityLiveRegions(line, parsedState.item_count);

        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && name) lineItem.querySelector(`[name="${name}"]`).focus();

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: {
              cart: state,
            },
          })
        );
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });

        // Update the pfand product quantity
        if (pfandVariantId && name != 'delete') {
          this.updatePfandProductQuantity(pfandVariantId, totalPfandHelperQty);
        }
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
        this.querySelector('.button-disabled')?.classList.remove('button-disabled');
        if (this.cartErrors) {
          this.cartErrors.textContent = theme.cartStrings.error;
        }
      });
  }

  updateErrorLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  updateQuantityLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const quantityError = document.getElementById(`Line-item-error-${line}`);
      if (quantityError) {
        quantityError.querySelector('.cart-item__error-text').innerHTML = theme.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
      }
    }

    this.currentItemCount = itemCount;

    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1e3);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.add('cart__items--disabled');

    const loadingOverlay = this.querySelectorAll('.loading-overlay')[line - 1];
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');

    document.activeElement.blur();
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.remove('cart__items--disabled');
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);

      if (element) {
        element.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });
  }

  updatePfandProductQuantity(pfandVariantId, quantity) {
    // console.log('updatePfandProductQuantity', pfandVariantId, quantity);
    const sections = this.getSectionsToRender().map((section) => section.section);

    // Use Shopify's cart update endpoint
    const body = JSON.stringify({
      updates: {
        [pfandVariantId]: quantity,
      },
      sections: sections,
      sections_url: window.location.pathname,
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body,
    })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        // console.log('parsedState pfand', parsedState);
        this.getSectionsToRender().forEach((section) => {
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace = element.querySelector(section.selector) || element;

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          }
        });

        // Re-enable buttons after successful pfand update
        this.disableLoading();
      })
      .catch((error) => {
        console.error('Error updating pfand product quantity:', error);
        // Re-enable buttons in case of error
        this.disableLoading();
      });
  }

  onExternalRefresh(detail = {}) {
    // --- Schutz vor mehrfachen Aufrufen ---
    if (this._refreshLock && Date.now() - this._refreshLock < 2000) {
      console.log('[CartItems] Refresh ignored (lock active)');
      return;
    }
    this._refreshLock = Date.now();

    console.log('[CartItems] Externes Refresh erkannt:', detail);

    const sections = this.getSectionsToRender().map((s) => s.section);
    const body = JSON.stringify({
      updates: detail.updates || {},
      sections: sections,
      sections_url: window.location.pathname,
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
    })
      .then((r) => r.text())
      .then((text) => {
        const parsedState = JSON.parse(text);
        this.getSectionsToRender().forEach((section) => {
          const element = document.getElementById(section.id);
          if (!element) return;
          const replace = element.querySelector(section.selector) || element;
          if (replace && parsedState.sections[section.section]) {
            replace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        this.disableLoading();

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: { cart: parsedState, source: detail.source || 'external' },
          })
        );
        console.log('[CartItems] Refresh abgeschlossen');
      })
      .catch((err) => {
        console.error('[CartItems] Fehler beim externen Refresh:', err);
        this.disableLoading();
      });
  }


}
customElements.define('cart-items', CartItems);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'change',
      debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300)
    );
  }
}
customElements.define('cart-note', CartNote);

class DiscountCode extends HTMLElement {
  constructor() {
    super();

    if (isStorageSupported('session')) {
      this.setupDiscount();

      this.addEventListener('change', (event) => {
        window.sessionStorage.setItem('discount', event.target.value);
      });
    }
  }

  setupDiscount() {
    const discount = window.sessionStorage.getItem('discount');
    if (discount !== null) {
      this.querySelector('input[name="discount"]').value = discount;
    }
  }
}

customElements.define('discount-code', DiscountCode);

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();

    this.setupCountries();

    this.errors = this.querySelector('#ShippingCalculatorErrors');
    this.success = this.querySelector('#ShippingCalculatorSuccess');
    this.zip = this.querySelector('#ShippingCalculatorZip');
    this.country = this.querySelector('#ShippingCalculatorCountry');
    this.province = this.querySelector('#ShippingCalculatorProvince');
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onSubmitHandler.bind(this));
  }

  setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('ShippingCalculatorCountry', 'ShippingCalculatorProvince', {
        hideElement: 'ShippingCalculatorProvinceContainer',
      });
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();

    this.errors.classList.add('hidden');
    this.success.classList.add('hidden');
    this.zip.classList.remove('invalid');
    this.country.classList.remove('invalid');
    this.province.classList.remove('invalid');
    this.button.classList.add('loading');
    this.button.setAttribute('disabled', true);

    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value,
      },
    });
    let sectionUrl = `${theme.routes.cart_url}/shipping_rates.json`;

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.success.classList.remove('hidden');
          this.success.innerHTML = '';

          parsedState.shipping_rates.forEach((rate) => {
            const child = document.createElement('p');
            child.innerHTML = `${rate.name}: ${rate.price} ${Shopify.currency.active}`;
            this.success.appendChild(child);
          });
        } else {
          let errors = [];
          Object.entries(parsedState).forEach(([attribute, messages]) => {
            errors.push(`${attribute.charAt(0).toUpperCase() + attribute.slice(1)} ${messages[0]}`);
          });

          this.errors.classList.remove('hidden');
          this.errors.querySelector('.errors').innerHTML = errors.join('; ');
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
      });
  }
}

customElements.define('shipping-calculator', ShippingCalculator);

if (!customElements.get('discount-coupon')) {
  class DiscountCoupon extends HTMLElement {
    constructor() {
      super();
      this.input = null;
      this.button = null;
      this.clearButton = null;
      this.handleSubmit = this.handleSubmit.bind(this);
      this.fetchCart();
    }

    connectedCallback() {
      this.input = this.querySelector('.discount-input');
      this.button = this.querySelector('.discount-submit');
      this.clearButton = this.querySelector('.discont-clear');

      if (this.button && this.input) {
        this.button.addEventListener('click', this.handleSubmit);
      }

      this.input.addEventListener('focus', () => {
        if (this.input.classList.contains('invalid')) {
          this.input.classList.remove('invalid');
          this.input.value = '';
        }
      });

      // this.input.addEventListener('blur', () => {
      //   this.input.classList.remove('is-focused');
      // });
    }

    async handleSubmit(event) {
      event.preventDefault();

      const code = this.input.value.trim().toLowerCase();
      let updatedCodes = null;

      const activate_code = this.querySelector('.discount-code__input-container')?.dataset.code?.trim();
      if (!code) return;
      // if (code == activate_code) {
      //   return;
      // }
      if (code) {
        const allCodes = Array.from(document.querySelectorAll('.discount-wrapper .code-name')).map((element) =>
          element.textContent.trim()
        );
        updatedCodes = [...new Set([...allCodes, code])];
      }
      const cartItems = document.querySelector('cart-items');
      const sections = cartItems?.getSectionsToRender().map((section) => section.section) || [];
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      this.querySelector('.btn-text').classList.add('btn-hidden');
      document.querySelector('.mini-cart__footer .loading-overlay__spinner').classList.remove('hidden');
      document.querySelector('.mini-cart__footer .btn-text').classList.add('btn-hidden');
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            discount: updatedCodes.join(','),
            sections: sections,
            sections_url: window.location.pathname,
          }),
        });

        if (response.ok) {
          const stateText = await response.text();
          const parsedState = JSON.parse(stateText);
          const applicableDiscounts = parsedState?.discount_codes.find((item) => item.code == code);

          this.updateSections(parsedState, cartItems);

          const discountInput = document.querySelector('.discount-input');
          discountInput.value = code;
          if (applicableDiscounts?.applicable) {
            discountInput.classList.add('valid');
          } else {
            discountInput.classList.add('invalid');
            document.querySelector('#cart .discount-wrapper .error-discount span').textContent = code;
          }

          document.querySelector('discount-coupon .loading-overlay__spinner').classList.add('hidden');
          document.querySelector('discount-coupon .btn-text').classList.remove('btn-hidden');
          if (applicableDiscounts?.applicable) {
            setTimeout(() => {
              document.querySelector('#cart .discount_wrapper__inner input.valid').classList.add('animation');
              document.querySelector('.discount_wrapper__inner .discount-success').classList.add('animation');
            }, 200);
            setTimeout(() => {
              if(!document.querySelector('#cart .discount_wrapper__inner input.valid')) return;
              document.querySelector('#cart .discount_wrapper__inner input.valid').classList.remove('animation');
              document.querySelector('.discount_wrapper__inner .discount-success').classList.remove('animation');
              discountInput.value = '';
              discountInput.classList.add('animation-timeout');
            }, 1000);

            const allDiscounts = Array.from(document.querySelectorAll('.discount-wrapper .code-name')).map((element) =>
              element.textContent.trim().toLowerCase()
            );
            if (!allDiscounts.includes(code) && applicableDiscounts?.applicable) {
              const shippingChip = `
                <span class="tag">
                  <span class="code">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M6.51778 13.5411C6.82111 13.8444 7.21778 14 7.61444 14C8.01111 14 8.40778 13.8444 8.71111 13.5411L13.5411 8.71111C14.1478 8.10444 14.1478 7.11667 13.5411 6.51L7.48222 0.451111C7.19444 0.163333 6.79778 0 6.38556 0H1.55556C0.7 0 0 0.7 0 1.55556V6.38556C0 6.79778 0.163333 7.19444 0.458889 7.48222L6.51778 13.5411ZM1.55556 1.55556H6.38556L12.4444 7.61444L7.61444 12.4444L1.55556 6.38556V1.55556Z" fill="#222222"></path>
                    </svg>
                    <span class="code-name">${code}</span>
                    <button type="button" class="cross-button" onclick="document.querySelector('discount-coupon').handleClear('${code}')" fdprocessedid="p5dvke">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M0.996094 12.8333L6.82943 6.99996M6.82943 6.99996L12.6628 1.16663M6.82943 6.99996L0.996094 1.16663M6.82943 6.99996L12.6628 12.8333" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                    </button>
                  </span>
                </span>`;
              document.querySelector('.discount-wrapper .discount-codes').insertAdjacentHTML('beforeend', shippingChip);
            }
          }
          publish('cart-update');
        } else {
          console.error('Failed to apply discount');
          // Optionally show error to user
        }
      } catch (err) {
        console.error('Error applying discount:', err);
        // Optionally show a generic error message
      }
    }

    async handleClear(removedCode) {
      const allCodes = Array.from(document.querySelectorAll('.discount-wrapper .code-name')).map((element) =>
        element.textContent.trim()
      );
      const remainingCodes = allCodes.filter((code) => code !== removedCode);
      let codesToApply = remainingCodes.length > 0 ? remainingCodes : '';
      if (codesToApply && codesToApply.length > 0) {
        codesToApply = codesToApply?.join(',');
      }

      const cartItems = document.querySelector('cart-items');
      const sections = cartItems?.getSectionsToRender().map((section) => section.section) || [];

      // Reset UI
      if (this.input.classList.contains('invalid')) {
        this.input.value = '';
        this.input.classList.remove('invalid');
        this.clearButton.classList.add('hidden');
        return;
      }
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      this.querySelector('.btn-text').classList.add('btn-hidden');
      document.querySelector('.mini-cart__footer .loading-overlay__spinner').classList.remove('hidden');
      document.querySelector('.mini-cart__footer .btn-text').classList.add('btn-hidden');

      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            discount: codesToApply,
            sections: sections,
            sections_url: window.location.pathname,
          }),
        });

        if (response.ok) {
          const stateText = await response.text();
          const parsedState = JSON.parse(stateText);
          const cartItems = document.querySelector('cart-items');
          this.updateSections(parsedState, cartItems);
        } else {
          console.error('Failed to clear discount');
        }

        document.querySelector('discount-coupon .loading-overlay__spinner').classList.add('hidden');
        document.querySelector('discount-coupon .btn-text').classList.remove('btn-hidden');
      } catch (err) {
        console.error('Error clearing discount:', err);
      }
    }

    updateSections(parsedState, cartItems) {
      cartItems?.getSectionsToRender().forEach((section) => {
        const element = document.getElementById(section.id);
        if (element && parsedState.sections[section.section]) {
          const elementToReplace = element.querySelector(section.selector) || element;
          elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        }
      });
    }

    fetchCart() {
      fetch(`${theme.routes.cart_url}.js`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then((response) => response.json())
        .then((cart) => {
          if (cart && cart.discount_codes && cart.discount_codes.length > 0) {
            const allDiscounts = Array.from(document.querySelectorAll('.discount-wrapper .code-name')).map((element) =>
              element.textContent.trim().toLowerCase()
            );

            const missingDiscounts = cart.discount_codes
              .filter(
                (codeObj) => codeObj.applicable === true && !allDiscounts.includes(codeObj.code.trim().toLowerCase())
              )
              .map((codeObj) => codeObj.code);

            if (missingDiscounts.length > 0) {
              const shippingChip = `
                <span class="tag">
                  <span class="code">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M6.51778 13.5411C6.82111 13.8444 7.21778 14 7.61444 14C8.01111 14 8.40778 13.8444 8.71111 13.5411L13.5411 8.71111C14.1478 8.10444 14.1478 7.11667 13.5411 6.51L7.48222 0.451111C7.19444 0.163333 6.79778 0 6.38556 0H1.55556C0.7 0 0 0.7 0 1.55556V6.38556C0 6.79778 0.163333 7.19444 0.458889 7.48222L6.51778 13.5411ZM1.55556 1.55556H6.38556L12.4444 7.61444L7.61444 12.4444L1.55556 6.38556V1.55556Z" fill="#222222"></path>
                    </svg>
                    <span class="code-name">${missingDiscounts.join(',')}</span>
                    <button type="button" class="cross-button" onclick="document.querySelector('discount-coupon').handleClear('${missingDiscounts.join(
                      ','
                    )}')" fdprocessedid="p5dvke">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M0.996094 12.8333L6.82943 6.99996M6.82943 6.99996L12.6628 1.16663M6.82943 6.99996L0.996094 1.16663M6.82943 6.99996L12.6628 12.8333" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                    </button>
                  </span>
                </span>`;
              document.querySelector('.discount-wrapper .discount-codes').insertAdjacentHTML('beforeend', shippingChip);
            }
          }
        })
        .catch((error) => {
          console.error('Error fetching cart:', error);
          return null;
        });
    }
  }

  customElements.define('discount-coupon', DiscountCoupon);
}

if (!customElements.get('cart-upsell')) {
  class CartUpsell extends HTMLElement {
    constructor() {
      super();
      this.initFlickity = this.initFlickity.bind(this);
      this.handleScrollbar = this.handleScrollbar.bind(this);
      this.moveFlickityButtons = this.moveFlickityButtons.bind(this);
      this.updateScrollbar = this.updateScrollbar.bind(this);
      setTimeout(() => {
        this.initFlickity();
      }, 50);
    }

    initFlickity() {
      if (typeof Flickity === 'undefined') {
        window.addEventListener('load', this.initFlickity);
        return;
      }

      const slider = this.querySelector('.upsell-slider');
      if (!slider) return;

      this.flickity = new Flickity(slider, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: true,
        wrapAround: false,
        pageDots: false,
        draggable: true,
        cellSelector: '.upsell-item',
        lazyLoad: false,
        watchCSS: false,
        groupCells: true,
        freeScroll: true,
      });

      // Re-measure when width changes (drawer opens from closed <details>, window resize)
      this.lastWidth = 0;
      new ResizeObserver(([entry]) => {
        const width = entry.contentRect.width;
        if (!width || width === this.lastWidth) return;
        this.lastWidth = width;
        this.flickity.resize();
      }).observe(slider);

      // Scrollbar setup
      this.scrollbarTrack = this.querySelector('.flickity-scrollbar-track');
      this.scrollbarThumb = this.querySelector('.flickity-scrollbar-thumb');

      if (this.scrollbarTrack && this.scrollbarThumb) {
        this.flickity.on('scroll', this.updateScrollbar);
        this.flickity.on('resize', this.updateScrollbar);
        this.flickity.on('ready', this.updateScrollbar);
        window.addEventListener('resize', this.updateScrollbar);
        this.updateScrollbar();
        this.bindScrollbarClick();
      }

      this.handleScrollbar();
      window.addEventListener('resize', this.handleScrollbar);
      window.addEventListener('load', this.handleScrollbar);

      setTimeout(this.moveFlickityButtons, 100);
      this.flickityEventForScrollbar();
    }

    updateScrollbar() {
      if (!this.flickity || !this.scrollbarTrack || !this.scrollbarThumb) return;

      const slideableWidth = this.flickity.slideableWidth;
      const viewportWidth = this.flickity.size.innerWidth;
      const scrollableWidth = slideableWidth - viewportWidth;
      const trackWidth = this.scrollbarTrack.offsetWidth;

      if (scrollableWidth <= 0) {
        this.scrollbarThumb.style.width = `${trackWidth}px`;
        this.scrollbarThumb.style.left = `0px`;
        return;
      }

      const scrollX = -this.flickity.x;
      let progress = scrollX / scrollableWidth;
      progress = Math.max(0, Math.min(1, progress));

      let thumbWidth = (viewportWidth / slideableWidth) * trackWidth;
      thumbWidth = Math.max(30, Math.min(trackWidth, thumbWidth));

      let thumbLeft = progress * (trackWidth - thumbWidth);

      if (thumbLeft + thumbWidth > trackWidth) {
        thumbLeft = trackWidth - thumbWidth;
      }
      if (thumbLeft < 0) thumbLeft = 0;

      this.scrollbarThumb.style.width = `${thumbWidth}px`;
      this.scrollbarThumb.style.left = `${thumbLeft}px`;
    }

    moveFlickityButtons() {
      if (!this.flickity || !this.flickity.isInitActivated) {
        setTimeout(() => this.moveFlickityButtons(), 200);
        return;
      }

      const titleWrapper = this.querySelector('.title-wrapper');
      const flickityButtons = this.querySelectorAll('.flickity-prev-next-button');

      if (!titleWrapper || flickityButtons.length !== 2) {
        return;
      }

      let btnContainer = titleWrapper.querySelector('.flickity-top-buttons');
      if (!btnContainer) {
        btnContainer = document.createElement('div');
        btnContainer.className = 'flickity-top-buttons';
        titleWrapper.appendChild(btnContainer);
      }

      flickityButtons.forEach((button) => {
        btnContainer.appendChild(button);
      });
    }

    handleScrollbar() {
      if (!this.flickity) return;

      if (window.innerWidth >= 750) {
        if (this.flickity.slides.length <= 4) {
          this.classList.add('hide-scrollbar');
        } else {
          this.classList.remove('hide-scrollbar');
        }
      } else {
        if (this.flickity.slides.length <= 1) {
          this.classList.add('hide-scrollbar');
        } else {
          this.classList.remove('hide-scrollbar');
        }
      }
    }

    bindScrollbarClick() {
      if (!this.scrollbarTrack || !this.flickity) return;

      this.scrollbarTrack.addEventListener('mousedown', (e) => {
        const trackRect = this.scrollbarTrack.getBoundingClientRect();
        const clickX = e.clientX - trackRect.left;
        const trackWidth = this.scrollbarTrack.offsetWidth;

        const clickRatio = clickX / trackWidth;

        const totalSlides = this.flickity.slides.length;
        const targetIndex = Math.floor(clickRatio * totalSlides);

        this.flickity.select(targetIndex);
      });
    }

    flickityEventForScrollbar() {
      this.flickity.on('scroll', () => {
        this.updateScrollbar();
        this.showScrollbarTemporarily();
      });

      this.flickity.on('select', () => {
        this.updateScrollbar();
        this.showScrollbarTemporarily();
      });

      this.flickity.on('dragStart', () => {
        this.showScrollbarTemporarily();
      });

      const flickityButtons = this.querySelectorAll('.flickity-prev-next-button');
      flickityButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.showScrollbarTemporarily());
      });
    }

    showScrollbarTemporarily() {
      if (!this.scrollbarThumb) return;

      clearTimeout(this.scrollbarTimeout);
      this.querySelector('.flickity-scrollbar').style.opacity = '1';

      this.scrollbarTimeout = setTimeout(() => {
        this.querySelector('.flickity-scrollbar').style.opacity = '0';
      }, 1000);
    }
  }

  customElements.define('cart-upsell', CartUpsell);
}
